export class PdaComboModel {
    tipoPratica?: string;
    filterMode: PdaFilterMode;
    filterValues: string[];
}

export enum PdaFilterMode {
    CATEGORIA_FASCICOLO,
    TIPO_FASCICOLO_CASSAZIONE
}